// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__yP85e","modal_close":"modal_modal_close__Xbf8A"};